import FocusableIconButton from '@components/FocusableIconButton';
import { usePatientSelectionContext } from '@context/PatientSelection';
import {
  FocusableComponentLayout,
  FocusContext,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';

import { makeExistingUser } from '../../../focuskey';

import * as styles from './styles';

const ExistingUsers = () => {
  const { patients, goNextStep, scrollToItem } = usePatientSelectionContext();
  const { ref, focusKey } = useFocusable();
  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.container}>
        {patients &&
          patients?.map((patient, index) => (
            <FocusableIconButton
              key={index}
              focusKey={makeExistingUser(index)}
              onEnterPress={() => goNextStep(patient.id)}
              iconType="check"
              // `ref` used both of scroll and focus
              onFocus={(layout: FocusableComponentLayout) => scrollToItem(ref, layout)}
              buttonStyle={styles.button}
            >
              {patient.name}
            </FocusableIconButton>
          ))}
      </div>
    </FocusContext.Provider>
  );
};

export default ExistingUsers;
